import React from 'react';
import { Box, Card, CardContent, Container, Grid, Typography } from '@material-ui/core';

const ChallengesGrid = ({ sectionConfig = {}, layoutContext = {}, globalConfig = {} }) => {
    const { applyHoverEffect, removeHoverEffect, getIcon, getAnimationProps } = layoutContext;
    const items = sectionConfig.items || [];

    if (!items.length) {
        return null;
    }

    const sectionLabel = sectionConfig.label || sectionConfig.defaultLabel || 'Challenges';
    const applyAnimation = (animationConfig, index = 0) => (
        typeof getAnimationProps === 'function' ? getAnimationProps(animationConfig, index) : {}
    );
    const sectionAnimation = applyAnimation(sectionConfig.animation?.section);
    const titleAnimation = applyAnimation(sectionConfig.animation?.title);

    return (
        <Box
            id="challenges-section"
            className={sectionAnimation.className}
            data-anim={sectionAnimation.dataAnim}
            data-delay={sectionAnimation.dataDelay}
            data-trigger-once={sectionAnimation.dataTriggerOnce}
            style={{ ...(sectionConfig.styles || {}), ...(sectionAnimation.style || {}) }}
        >
            <Container maxWidth={sectionConfig.container?.maxWidth || 'lg'} style={sectionConfig.containerStyles || {}}>
                <Box
                    className={titleAnimation.className}
                    data-anim={titleAnimation.dataAnim}
                    data-delay={titleAnimation.dataDelay}
                    data-trigger-once={titleAnimation.dataTriggerOnce}
                    style={{ ...(sectionConfig.titleContainerStyles || {}), ...(titleAnimation.style || {}) }}
                >
                    {sectionLabel && (
                        <Typography variant={sectionConfig.typography?.label?.variant || 'body2'} style={sectionConfig.labelStyles || {}}>
                            {sectionLabel}
                        </Typography>
                    )}
                    <Typography variant={sectionConfig.typography?.title?.variant || 'h2'} style={sectionConfig.titleStyles || {}}>
                        {sectionConfig.title || globalConfig.challenges?.title}
                    </Typography>
                    {sectionConfig.subtitle && (
                        <Typography variant={sectionConfig.typography?.subtitle?.variant || 'body1'} style={sectionConfig.subtitleStyles || {}}>
                            {sectionConfig.subtitle}
                        </Typography>
                    )}
                </Box>
                <Grid container spacing={sectionConfig.grid?.spacing || 2}>
                    {items.map((challenge, index) => {
                        const cardAnimation = applyAnimation(sectionConfig.animation?.items, index);
                        return (
                        <Grid
                            item
                            xs={sectionConfig.gridItem?.xs || 12}
                            sm={sectionConfig.gridItem?.sm || 6}
                            md={sectionConfig.gridItem?.md || 4}
                            key={`challenge-${index}`}
                        >
                            <Card
                                className={cardAnimation.className}
                                data-anim={cardAnimation.dataAnim}
                                data-delay={cardAnimation.dataDelay}
                                data-trigger-once={cardAnimation.dataTriggerOnce}
                                style={{ ...(sectionConfig.cardStyles || {}), ...(cardAnimation.style || {}) }}
                                onMouseEnter={(event) => applyHoverEffect?.(event, sectionConfig.cardHoverStyles || {})}
                                onMouseLeave={(event) => removeHoverEffect?.(event, sectionConfig.cardStyles || {})}
                            >
                                <CardContent style={sectionConfig.cardContentStyles || {}}>
                                    <Box style={sectionConfig.iconContainerStyles || {}}>
                                        <Box style={sectionConfig.iconBoxStyles || {}}>
                                            <Box style={{ ...(sectionConfig.iconStyles || {}), color: challenge.iconColor }}>
                                                {getIcon?.(challenge.icon)}
                                            </Box>
                                        </Box>
                                        <Typography variant={sectionConfig.typography?.cardTitle?.variant || 'h6'} style={sectionConfig.titleItemStyles || {}}>
                                            {challenge.title}
                                        </Typography>
                                    </Box>
                                    <Typography variant={sectionConfig.typography?.cardDescription?.variant || 'body2'} style={sectionConfig.descriptionStyles || {}}>
                                        {challenge.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};

export default ChallengesGrid;
